import { render, staticRenderFns } from "./modele-planning-body.vue?vue&type=template&id=08a11534&scoped=true"
import script from "./modele-planning-body.vue?vue&type=script&lang=js"
export * from "./modele-planning-body.vue?vue&type=script&lang=js"
import style0 from "./modele-planning-body.vue?vue&type=style&index=0&id=08a11534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a11534",
  null
  
)

export default component.exports